import React, { useState } from 'react';
import Modal from 'react-modal';
import { SecondaryButton } from '@workday/canvas-kit-react/button';
import { autoId, useReactModal } from '@workday/upc-common';
import { ID_EMAIL_PREFERENCE_BUTTON } from '../../../../autoIds';
import { EmailPreferences } from '../../preferences/email-preferences/email-preferences';
import { useHistory, useRouteMatch } from 'react-router-dom';
import { EMAIL_PREFERENCES_PATH, SETTINGS_PATH } from '../../../../react-router-paths';
import { useTranslation } from 'react-i18next';

export function EmailSettingsRow() {
    const { t } = useTranslation('account');
    const history = useHistory();
    const match = useRouteMatch(EMAIL_PREFERENCES_PATH);

    const openFromRoute = match ? match.isExact : false;

    const [isOpen, setIsOpen] = useState(false);

    const emailPreferenceModal = useReactModal({ modalProps: { onRequestClose: closeModal } });

    function openModal() {
        setIsOpen(true);
    }

    function closeModal() {
        if (openFromRoute) {
            history.replace(SETTINGS_PATH);
        } else {
            setIsOpen(false);
        }
    }

    const { modalProps } = emailPreferenceModal;

    return (
        <div className='settingsRow'>
            <h1 className='settingsRow__title'>{t('EmailSettingsRow.emailNotification')}</h1>
            <div className='settingsRow__content'>
                <p>{t('EmailSettingsRow.manageYourEmail')}</p>
                <SecondaryButton {...autoId(ID_EMAIL_PREFERENCE_BUTTON)} type='button' onClick={openModal}>
                    {t('EmailSettingsRow.openModal')}
                </SecondaryButton>
                <Modal {...modalProps} isOpen={isOpen || openFromRoute}>
                    <EmailPreferences onCancel={closeModal} />
                </Modal>
            </div>
        </div>
    );
}
